import MessagingTemplateCard from './messagingTemplateCard.view';

export default MessagingTemplateCard;
